// MANISH AEROSONIC REFFILE CODE START - JS (Custom Non-Variant Version) main code in product-info.liquide file 
document.addEventListener('DOMContentLoaded', function() {

  // --- Configuration ---
  const maxTotalQuantity = 2;

  // --- DOM Elements ---
  const popup = document.getElementById('fragrance-popup');
  const selectorBtn = document.getElementById('fragrance-selector-btn');
  const confirmBtn = document.getElementById('confirm-selection');
  const cancelBtn = document.getElementById('cancel-selection');
  const closeBtn = document.querySelector('.close-popup');
  const fragranceOptions = document.querySelectorAll('.fragrance-option');
  const mainProductForm = document.querySelector('form[id*="product-form"]');
  const mainProductVariantIdInput = mainProductForm ? mainProductForm.querySelector('input[name="id"]') : null;

  // --- State Management ---
  const selections = new Map(); // fragranceId -> { name, quantity }

  // --- Event Listeners ---
  if (selectorBtn) selectorBtn.addEventListener('click', openPopup);
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (cancelBtn) cancelBtn.addEventListener('click', closePopup);
  if (confirmBtn) confirmBtn.addEventListener('click', confirmSelection);

  fragranceOptions.forEach(option => {
    const fragranceId = option.dataset.fragranceId;
    const selectBtn = option.querySelector('.btn--select-fragrance');
    const minusBtn = option.querySelector('.qty-minus');
    const plusBtn = option.querySelector('.qty-plus');

    if (selectBtn) selectBtn.addEventListener('click', () => handleInitialSelect(fragranceId));
    if (minusBtn) minusBtn.addEventListener('click', () => updateQuantity(fragranceId, -1));
    if (plusBtn) plusBtn.addEventListener('click', () => updateQuantity(fragranceId, 1));
  });

  window.addEventListener('click', function(event) {
    if (event.target === popup) {
      closePopup();
    }
  });

  // --- Core Functions ---

  function openPopup() {
    if (!popup) return;
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-active');
    document.body.style.overflow = '';
    resetSelections();
  }

  function resetSelections() {
    selections.clear();
    fragranceOptions.forEach(option => {
      const selectBtn = option.querySelector('.btn--select-fragrance');
      const quantityControl = option.querySelector('.fragrance-quantity-control');
      const input = option.querySelector('.quantity-input');
      
      option.classList.remove('has-selection');
      selectBtn.classList.remove('is-hidden');
      quantityControl.classList.add('is-hidden');
      if (input) input.value = 1;
    });
    updateConfirmButton();
  }

  function handleInitialSelect(fragranceId) {
    const totalQuantity = getTotalSelectedQuantity();
    if (totalQuantity >= maxTotalQuantity) return;

    const option = document.querySelector(`.fragrance-option[data-fragrance-id="${fragranceId}"]`);
    if (!option) return;
    const fragranceName = option.querySelector('h4').textContent;

    selections.set(fragranceId, { name: fragranceName, quantity: 1 });

    // Update UI
    const selectBtn = option.querySelector('.btn--select-fragrance');
    const quantityControl = option.querySelector('.fragrance-quantity-control');
    
    selectBtn.classList.add('is-hidden');
    quantityControl.classList.remove('is-hidden');
    option.classList.add('has-selection');

    updateConfirmButton();
  }

  function updateQuantity(fragranceId, change) {
    const selection = selections.get(fragranceId);
    if (!selection) return;

    const newQuantity = selection.quantity + change;
    const totalQuantity = getTotalSelectedQuantity() + change; // Calculate total after change

    if (newQuantity < 1 || totalQuantity > maxTotalQuantity) {
      return;
    }

    selection.quantity = newQuantity;
    selections.set(fragranceId, selection);

    // Update UI
    const option = document.querySelector(`.fragrance-option[data-fragrance-id="${fragranceId}"]`);
    const input = option.querySelector('.quantity-input');
    if (input) input.value = newQuantity;
    
    updateConfirmButton();
  }

  function getTotalSelectedQuantity() {
    let total = 0;
    for (const selection of selections.values()) {
      total += selection.quantity;
    }
    return total;
  }

  function updateConfirmButton() {
    const totalQuantity = getTotalSelectedQuantity();
    if (confirmBtn) {
      confirmBtn.textContent = `Confirm selection (${totalQuantity}/${maxTotalQuantity})`;
      confirmBtn.disabled = (totalQuantity !== maxTotalQuantity);
    }
  }

  async function confirmSelection() {
    if (getTotalSelectedQuantity() !== maxTotalQuantity) return;
    if (!mainProductForm || !mainProductVariantIdInput) {
        console.error("Main product form or variant ID input not found.");
        alert("An error occurred. Please refresh the page and try again.");
        return;
    }

    // Build the line item properties object
    const properties = {};
    let propertyIndex = 1;
    // Sort selections by name for consistent order in cart
    const sortedSelections = Array.from(selections.entries()).sort((a, b) => a[1].name.localeCompare(b[1].name));

    for (const [id, selection] of sortedSelections) {
      if (selection.quantity === 2) {
        properties[`Fragrance ${propertyIndex}`] = `${selection.name} (x2)`;
      } else {
        properties[`Fragrance ${propertyIndex}`] = selection.name;
      }
      propertyIndex++;
    }

    const formData = new FormData(mainProductForm);
    formData.set('id', mainProductVariantIdInput.value);
    formData.set('quantity', '1'); // Always adding one "set"

    // Add our custom properties to the form data
    for (const [key, value] of Object.entries(properties)) {
      formData.set(`properties[${key}]`, value);
    }
    
    if (confirmBtn) {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Unknown error');
      }

      const data = await response.json();
      console.log('Added to cart:', data);

      closePopup();
      
      // Trigger Shopify's standard event to update cart UI (like cart drawer)
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: data,
          quantity: 1
        }
      }));

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(`There was an issue adding your selection: ${error.message}`);
      updateConfirmButton(); 
    }
  }
});
// MANISH AEROSONIC REFFILE CODE END - JS (Custom Non-Variant Version)